"use client";

import { useState } from "react";
import { ImageResponsiveProps } from "./Image.types";
import assetLoader from "@utils/internalImageLoder";
import Image from "next/image";
import {
  useScreenSizeDetection,
  useImageSizeSelection,
  useResponsiveProps,
  getImageStyle,
} from "./BaseImageResponsive";

const ImageResponsive = ({
  filePath,
  imageTag,
  alt = "image",
  width,
  height,
  className = "",
  fill,
  priority = false,
  style,
  onClickHandler,
  containerClassName = "",
}: ImageResponsiveProps) => {
  const [useOriginal, setUseOriginal] = useState(false);

  if (fill && (width || height)) {
    console.warn("Width and height props are ignored when fill is true.");
  }

  const baseUrl = `https://ackodrive-prod.ackoassets.com/image/${filePath}/images_cdn`;
  const originalSrc = `${assetLoader()}/images/placeHolder-FallbackImage.png`;

  const handleError = () => {
    console.log("error in url", baseUrl);
    setUseOriginal(true);
  };

  // Use common screen size detection
  const screenSize = useScreenSizeDetection();

  // Use common image size selection
  const effectiveWidth = screenSize.viewportWidth > 0 
    ? screenSize.viewportWidth 
    : screenSize.width > 0 
      ? screenSize.width 
      : width;

  const { imageSrc } = useImageSizeSelection(
    screenSize,
    effectiveWidth,
    baseUrl,
    imageTag
  );

  // Use common responsive props
  const responsiveProps = useResponsiveProps(fill, width, height);

  // Use common image style
  const imageStyle = getImageStyle(fill, width, height, style);

  const finalClassName = `${className} ${useOriginal ? "fallback-image" : ""}`;
  
  return (
    <div onClick={onClickHandler} className={containerClassName}>
      <Image
        src={useOriginal ? originalSrc : imageSrc}
        alt={alt}
        className={finalClassName}
        {...responsiveProps}
        style={imageStyle}
        loading={priority ? "eager" : "lazy"}
        onError={handleError}
      />
    </div>
  );
};

export default ImageResponsive;
